"use strict";

exports.__esModule = true;
exports.MetricTableFields = MetricTableFields;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _Translator = require("../../Core/Translator");
var _MetricSelector = require("../../Metrics/MetricSelector");
var _fetchSection = require("../../VIMANAMetrics/Sections/fetchSection");
var _Fields = require("../AdvancedDataTable/Fields");
var _MetricsFilters = require("../common/MetricsFilters");
var _MultiAggregateSelector = require("../common/MultiAggregateSelector");
var _DataTable = require("../DataTable");
var _metrics = require("../DataTable/DataSources/metrics");
var _Fields2 = require("../DataTable/Fields");
var _createTableColumns = require("./createTableColumns");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var MetricFieldFormGroup = (0, _styledComponents["default"])(_core.FormGroup).withConfig({
  displayName: "MetricTableFields__MetricFieldFormGroup",
  componentId: "sc-1f0twvg-0"
})(["margin-bottom:0;"]);
function MetricTableFields(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var element = props.element,
    elementEditor = props.elementEditor,
    path = props.path;
  var aggregates = (0, _fetchSection.fetchSection)("aggregates");
  var metrics = (0, _fetchSection.fetchSection)("metrics");
  var configuration = element.props.configuration;
  var definition = (0, _metrics.metricsDefinition)();
  if (!configuration) {
    configuration = (0, _DataTable.boostrapDefaultColumns)(configuration, elementEditor, definition, path);
  }
  var aggregationItems = (0, _MetricsFilters.flattenAggregates)(aggregates);
  var metricItems = (0, _MetricsFilters.flattenMetrics)(metrics);
  var selectedAggregates = element.children.map(function (child) {
    return child.props;
  }).filter(function (child) {
    return child.section === "aggregates";
  });
  var selectedMetrics = element.children.map(function (child) {
    return child.props;
  }).filter(function (child) {
    return child.section === "metrics";
  });
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_MultiAggregateSelector.MultiAggregateSelector, {
    style: {
      marginBottom: 0
    },
    items: aggregationItems,
    tags: aggregates.map(function (_ref) {
      var name = _ref.name;
      return name;
    }),
    selected: selectedAggregates,
    onSelect: function onSelect(selected) {
      var groups = selected.reduce(function (acc, item) {
        acc[item.groupId] = item;
        return acc;
      }, {});
      var values = Object.values(groups);
      if (!(0, _reactFastCompare["default"])(selectedAggregates, values)) {
        var cols = (0, _createTableColumns.createTableColumns)(values.concat(selectedMetrics));
        elementEditor.replaceElementAt(path, Object.assign({}, element, {
          children: cols
        }));
      }
    }
  }), /*#__PURE__*/_react["default"].createElement(MetricFieldFormGroup, {
    label: translate("MetricTableFields.MultiMetricSelector.placeholder.multiple", "Select Metrics")
  }, /*#__PURE__*/_react["default"].createElement(_MetricSelector.MetricSelector, {
    dataTestId: "MetricTableFields.MetricSelector",
    multiple: true,
    items: metricItems,
    selected: selectedMetrics,
    onSelect: function onSelect(selected) {
      if (!(0, _reactFastCompare["default"])(selectedMetrics, selected)) {
        elementEditor.replaceElementAt(path, Object.assign({}, element, {
          children: (0, _createTableColumns.createTableColumns)(selectedAggregates.concat(selected))
        }));
      }
    }
  })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(MetricFieldFormGroup, {
    key: "MetricTableFields.MetricFilters",
    label: /*#__PURE__*/_react["default"].createElement("h4", {
      style: {
        marginBottom: "0",
        marginTop: "0"
      }
    }, translate("MetricTableFields.filters.heading", "Filters")),
    labelInfo: translate("MetricTableFields.filters.helperText", "Metrics will be computed based on selected filters")
  }, /*#__PURE__*/_react["default"].createElement(_MetricsFilters.MetricFilters, props)), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(MetricFieldFormGroup, {
    key: "MetricTableFields.PivotByTime",
    label: /*#__PURE__*/_react["default"].createElement("h4", {
      style: {
        marginBottom: "0",
        marginTop: "0"
      }
    }, translate("MetricTableFields.pivotByTime.heading", "Pivot by Time")),
    labelInfo: translate("MetricTableFields.pivotByTime.helperText", "Aggregate values will show up as columns")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      marginTop: "5px"
    }
  }, /*#__PURE__*/_react["default"].createElement(_MetricsFilters.PivotByTimeFilter, _extends({
    selectedAggregates: selectedAggregates
  }, props)))), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataRangeSelector, {
    value: element.props.dataRange || "",
    setProp: function setProp(value) {
      elementEditor.setProp(path, "dataRange", value);
    },
    fetchDataOnlyOnSelection: element.props.fetchDataOnlyOnSelection,
    setFetchOnlyOnSelection: function setFetchOnlyOnSelection(value) {
      elementEditor.setProp(path, "fetchDataOnlyOnSelection", value);
    }
  }), /*#__PURE__*/_react["default"].createElement(_Fields2.PaginationField, {
    defaultPageSize: configuration.defaultPageSize,
    setDefaultPageSize: function setDefaultPageSize(val) {
      return elementEditor.setProp(path, "configuration", Object.assign({}, element.props.configuration, {
        defaultPageSize: val
      }));
    },
    pageSizes: element.props.pageSizes
  }));
}